import { Grid2 as Grid, Typography } from "@mui/material";
import { useMemo } from "react";
import {
  AdditionalInfo,
  Parameter,
  ParameterDefinition,
} from "../../graphql/generated";
import { ResourceDisplayNameInput } from "../ResourceConfigForm/ParameterInput/ResourceDisplayNameInput";
import { ParameterSection } from "../ResourceConfigForm/ParameterSection";
import { useResourceFormValues } from "../ResourceConfigForm/ResourceFormContext";
import { groupParameters } from "../ResourceConfigForm/utils";
import { ViewHeading } from "./ViewHeading";
import mixins from "../../styles/mixins.module.scss";
import styles from "./resource-form.module.scss";

interface Props {
  title?: string;
  description?: string;
  additionalInfo?: AdditionalInfo | null;
  parameterDefinitions: ParameterDefinition[];
  parameters?: Parameter[];
  stability?: string;
  resourceDocLink?: string;
}

export const ResourceForm: React.FC<Props> = ({
  title,
  description,
  additionalInfo,
  parameterDefinitions,
  stability,
  resourceDocLink,
}) => {
  const { formValues, setFormValues } = useResourceFormValues();
  const groups = useMemo(
    () => groupParameters(parameterDefinitions),
    [parameterDefinitions],
  );

  return (
    <>
      <Grid container spacing={3} className={mixins["mb-3"]}>
        <Grid size={{ xs: 12 }}>
          <ViewHeading
            heading={title}
            subHeading={description}
            additionalInfo={additionalInfo}
            stability={stability}
            resourceDocLink={resourceDocLink}
          />
        </Grid>
      </Grid>
      <form className={styles.form}>
        <Grid
          container
          spacing={3}
          className={mixins["mb-5"]}
          paddingTop={"8px"}
        >
          <Grid size={{ xs: 7 }}>
            <ResourceDisplayNameInput
              value={formValues.displayName}
              onValueChange={(v: string) =>
                setFormValues((prev) => ({ ...prev, displayName: v }))
              }
            />
          </Grid>
          {groups.length === 0 ? (
            <Grid>
              <Typography>No additional configuration needed.</Typography>
            </Grid>
          ) : (
            <>
              {groups.map((g, ix) => (
                <ParameterSection
                  key={`param-group-${ix}`}
                  group={g}
                  readOnly={false}
                />
              ))}
            </>
          )}
        </Grid>
      </form>
    </>
  );
};
